import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { t } from '../../localization.js';
import Collapse from '../Collapse/Collapse.js';
import Divider from '../Divider/Divider.js';
import Toggle from '../Toggle/Toggle.js';
import styles from './Description.module.scss.js';

var MAX_LINES_COUNT = 5;
var LINE_HEIGHT = 20;
var MAX_HEIGHT_DESCRIPTION = LINE_HEIGHT * MAX_LINES_COUNT;
var fadeTimeout = 300;
var Description = (function (_super) {
    __extends(Description, _super);
    function Description(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = function () {
            _this.updateDescriptionToggleOverflowState(_this.props.children);
        };
        _this.onClick = function () {
            _this.setState({
                isOpened: !_this.state.isOpened,
                isCollapseAnimationEnd: false,
            });
        };
        _this.renderDivider = function () {
            return React.createElement(Divider, { type: "major" });
        };
        _this.state = {
            isToggle: false,
            isOpened: false,
            isOverflowed: false,
            isCollapseAnimationEnd: true,
        };
        return _this;
    }
    Description.prototype.componentDidMount = function () {
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', this.onResize);
        this.updateDescriptionToggleOverflowState(this.props.children);
    };
    Description.prototype.componentWillUnmount = function () {
        window === null || window === void 0 ? void 0 : window.removeEventListener('resize', this.onResize);
    };
    Description.prototype.UNSAFE_componentWillReceiveProps = function (_a) {
        var children = _a.children;
        if (children !== this.props.children) {
            this.updateDescriptionToggleOverflowState(children);
        }
    };
    Description.prototype.updateDescriptionToggleOverflowState = function (description) {
        var _a = this.isNeedToggleAndDots(description), isOverflowed = _a[0], isToggle = _a[1];
        this.setState({
            isOverflowed: isOverflowed,
            isToggle: isToggle,
        });
    };
    Description.prototype.isNeedToggleAndDots = function (description) {
        var lines = description
            .replace(/<(\/?p|br\/?)>/g, '')
            .split('\n')
            .slice(0, -1);
        lines = lines.filter(function (line, index) { return !index || line || lines[index - 1]; });
        var width = this._descriptionBlock ? this._descriptionBlock.offsetWidth : 0;
        var styles = window === null || window === void 0 ? void 0 : window.getComputedStyle(this._descriptionBlock);
        var fontSize = styles ? styles.getPropertyValue('font-size') : '14px';
        var fontFamily = styles ? styles.getPropertyValue('font-family') : 'sans-serif';
        var span = document.createElement('span');
        document.body.appendChild(span);
        span.style.display = 'block';
        span.style.fontFamily = fontFamily;
        span.style.fontSize = fontSize;
        span.style.lineHeight = LINE_HEIGHT + "px";
        span.style.minHeight = LINE_HEIGHT + "px";
        span.style.visibility = 'hidden';
        span.style.whiteSpace = 'normal';
        span.style.width = width + "px";
        span.style.wordBreak = 'break-word';
        var actualLines = 0;
        var currentLines = 0;
        var needDots = false;
        for (var i = 0; i < MAX_LINES_COUNT; i++) {
            if (lines[i] === undefined) {
                break;
            }
            span.innerHTML = lines[i];
            currentLines = Math.ceil(span.offsetHeight / LINE_HEIGHT);
            actualLines += currentLines;
            if (actualLines > MAX_LINES_COUNT) {
                needDots = currentLines > 1;
                break;
            }
        }
        span.innerHTML = description;
        var needToggle = span && span.offsetHeight ? span.offsetHeight > MAX_HEIGHT_DESCRIPTION : false;
        document.body.removeChild(span);
        return [needDots, needToggle];
    };
    Description.prototype.renderToggleButton = function () {
        if (this.state.isToggle) {
            var content = null;
            if (this.state.isCollapseAnimationEnd) {
                content = (React.createElement(ReactCSSTransitionGroup, { transitionName: "fade", transitionAppear: true, transitionEnter: false, transitionLeaveTimeout: fadeTimeout, transitionAppearTimeout: fadeTimeout },
                    React.createElement(Toggle, { key: "clan-description-toggle", caption: this.state.isOpened ? t('Свернуть описание') : t('Развернуть описание'), onClick: this.onClick })));
            }
            return React.createElement("div", { className: styles.toggle }, content);
        }
        return null;
    };
    Description.prototype.render = function () {
        var _a;
        var _this = this;
        var classNameTextDescription = classNames(styles.text, this.props.className, (_a = {},
            _a[styles.isOpened] = this.state.isOpened,
            _a[styles.isOverflowed] = this.state.isOverflowed,
            _a[styles.isToggle] = this.state.isToggle,
            _a));
        return (React.createElement("div", { className: styles.description },
            this.renderDivider(),
            React.createElement("div", { className: styles.inner },
                React.createElement(Collapse, { onRest: function () { return _this.setState({ isCollapseAnimationEnd: true }); }, defaultHeight: MAX_HEIGHT_DESCRIPTION, isOpened: this.state.isOpened },
                    React.createElement("div", { ref: function (el) {
                            if (el) {
                                _this._descriptionBlock = el;
                            }
                        }, className: classNameTextDescription, dangerouslySetInnerHTML: { __html: this.props.children } })),
                this.renderToggleButton()),
            this.renderDivider()));
    };
    return Description;
}(React.PureComponent));

export { Description as default };
//# sourceMappingURL=Description.js.map
